import React from 'react';
import { ListParams } from '../../Common/types';
import { css, StyleSheet } from '../../Common/styling';
import { paginationDefaults } from '../commonSchema';
import { RadioButtonChecked as CallMadeIcon } from '@mui/icons-material';
import { FormControlLabel, Switch } from '@mui/material';

const styles = StyleSheet.create({
  callMadeIcon: {
    position: 'relative',
    bottom: '3px',
    paddingRight: '10px',
    verticalAlign: 'middle',
    color: '#fee721',
  },
});

type Props = {
  fieldName: string;
  label: string;
  listParams: ListParams;
  setGetListParams: (p: ListParams) => void;
  setSelectedRowItems: (p: []) => void;
  setQuickActionItem: (p: []) => void;
  setPagination?: (p: { page: number; page_size: number }) => void;
  paginationDefaults?: { page: number; page_size: number };
};

const CalledFilterSwitch: React.FC<Props> = (props) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
      <p>
        <CallMadeIcon className={css(styles.callMadeIcon)} />
        {props.label}
      </p>

      <FormControlLabel
        control={
          <Switch
            checked={!props.listParams[props.fieldName as keyof ListParams]}
            onChange={(e): void => {
              if (props.setPagination) {
                props.setPagination({
                  page: 1,
                  page_size: props.paginationDefaults
                    ? props.paginationDefaults.page_size
                    : paginationDefaults.page_size,
                });
              }
              props.setGetListParams({ ...props.listParams, [props.fieldName]: !e.target.checked });
              props.setSelectedRowItems([]);
              props.setQuickActionItem([]);
            }}
          />
        }
        label=""
        labelPlacement="start"
      />
    </div>
  );
};

export default CalledFilterSwitch;
